<template>
  <div class="m-content">
	<template v-for="item in results">
		<HeaderBox/>
    <div class="report-content">
      <div class="introdution">
        <h3>因何满足，为何放弃。</h3>
        <p>影响我们做决策的因素很多，其中一个无时无刻不在影响我们的因素是价值观。所谓价值观就是你更看重什么，
        在选择时不可回避并默默影响你的因素。了解“什么对我来说是重要的”“人生中我积累什么让我有成就感”，
        有助于帮助你将有限的时间和精力用到自己看重的人和事情上，同时也能够帮助你进行职业目标定位。</p>
      </div>
      <div class="report-area">
        <p class="report-title">各项的价值观类型得分</p>
        <img class="report-img score-img":src=item.cosValue.valueImageUrl />
      </div>
      <div class="report-area">
        <p class="report-title">你的价值观类型</p>
        <p class="type-name" v-html="item.cosValue.highestValue"></p>
        <p v-html="item.cosValue.highestValueDesc1"></p>
      </div>
      <div class="report-area">
        <p class="report-title">做符合自己价值观的事，你可以</p>
        <p v-html="item.cosValue.highestValueDesc2"></p>
      </div>
      <div class="report-area">
        <p class="report-title">认可方式</p>
        <p v-html="reportText[typeIndex].recognition"></p>
      </div>
      <div class="report-area">
        <p class="report-title">工作倾向</p>
        <p v-html="reportText[typeIndex].orientation"></p>
      </div>
    </div>
		<FootBox :id="id"/>
	</template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
import setWechatTitle from '@/utils/setWechatTitle.js'

export default {
  props: {
    id: Number
  },
  name: 'LiveReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      results:[],
      typeIndex:0,
      reportText:[
        {'type':'创造型','recognition':'创造出了财富或者一定影响力的事情，是他们获取认可最重要的方式。此外，创造型的人通常以自我为中心，要求很高的知名度和公众认可。','orientation':'创造型的人喜欢实现创造的需求，容易对过去的事情感到厌倦。在自己的企业中，他们仍会不断地创造新的产品或服务，当他们失去兴趣时就把这个企业卖掉再创建一个新的企业，他们需要不断接受新的挑战。'},
        {'type':'服务型','recognition':'比金钱更重要的是认可他们的贡献，给他们更多的权力和自由来体现他们自己的价值。','orientation':'那些帮助性的职业最能得到此类人的认同，例如护理、社会工作者、教育和公共管理等。此外，在公司中也存在以服务为导向的职业，例如，采取积极行动的人力资源专家，致力于提高劳资关系的劳动法律师，研究新药物的科学家，或为提高某一方面的社会现状进入公共服务领域的经理人。能够体现助人为乐、为国家和人类服务等价值观的工作是他们职业的首选。'},
        {'type':'挑战型','recognition':'对自己接受挑战、问题解决等能力和品质的认可。','orientation':'对于挑战型的人来说，选择职业时以“新奇、变化、挑战”为中心，工作理想与否最重要的是看能否经常提供挑战自我的机会；缺少自我挑战的机会会使他们变得厌倦和急躁。职业中的变化对他们而言非常重要，管理工作吸引他们的一个主要原因是管理工作的多变性和面临的挑战性。'},
        {'type':'独立型','recognition':'独立型的人最喜欢直接的表扬和认可，勋章、证书、推荐信、奖品、证书等奖励方式比晋升、获得头衔甚至金钱更具有吸引力。','orientation':'自主型的人更喜欢独来独往，在选择职业时最看重寻求宽松自由的工作环境，喜欢专业领域内职责描述清晰、目标明确、时间明确的工作，不喜欢被限制工作完成方式，不能忍受别人在旁边指手画脚。'},
        {'type':'管理型','recognition':'对于管理型的人来说，提升到有更大管理责任的职位无疑是最好的认可方式。他们以级别、头衔、薪水、下属数量、预算规模等的组合来衡量自己的地位。他们期望不断得到提升，如果在一个职位上呆的时间过长，就会觉得自己表现得不够好。他们也非常重视金钱形式的认同，像加薪、奖金和股票期权，喜欢头衔、地位象征，最重要的是得到上司的认可。','orientation':'管理型的人选择职业时最看重拥有更大的权力、处于更高的地位，可以管理并影响他人。对组织成功越重要的工作，对他们越具有吸引力。追求并致力于职位晋升，愿意承担整体的责任，并将公司的成功与否看作衡量自己工作成就的标准，具体的职能工作仅仅被看作是通向更高级管理层的必经之路。'},
        {'type':'职能型','recognition':'职能型的人更加需要同行专业人士的认可，而非管理者的表扬。另外一种认可的形式，是在专业领域继续学习和发展的机会、接受培训的机会、组织赞助的休假、鼓励参加专业的会议、提供购买资料和设备的经费等。除了继续学习，作为专家被接纳为其他团体或组织的成员也是他们喜欢的认可方式。','orientation':'职能型的人在选择职业时最看重：施展自己的技术专长，解决具体的技术或专业问题；期望具有一定挑战性的工作，如果一项工作不能考验他们的能力和技术水平，那么很快他们就对这份工作失去兴趣。由于他们的自尊取决于才能的施展水平，所以他们需要能够展现自己才能的工作。'},
        {'type':'生活型','recognition':'生活中的各个部分能够协调统一地向前发展。','orientation':'生活型的人职业决策受到与家庭、个人关注点及其他活动保持平衡的强烈影响。其认同感更多的与整体生活方式相联系而非某个具体的工作、领域或机构；喜欢为提供灵活选择的组织工作，如提供弹性工作制、在家办公等。生活型的人更关注组织文化是否尊重个人和家庭的需要。'},
        {'type':'安全型','recognition':'安全型的人希望因为忠诚和稳定的绩效而被认可，并且希望得到稳定和连续雇佣的保证。最重要的是，他们相信忠诚会给组织绩效带来实质贡献。','orientation':'稳定型的人愿意从事安全、稳定、可预见的职业。相比工作本身，他们更加关心的是工作的内容。工作环境、工作挑战等内在激励方式不如直接加薪、改善收益状况对他们更有效。这种类型的人通常会选择提供终身雇佣、从不辞退员工、有良好的退休金计划和福利体系，同时看上去强大而可靠的公司。因此，政府部门和事业单位对这类人来说很有吸引力。他们会为自己的组织感到自豪。'}
      ]
    };
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created: function () {
    setWechatTitle('生涯驿站-生涯罗盘')
    this.getReport()
  },
  methods:{
    getReport(result){
        this.results=[];
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),
          url:'/cob/cosValueReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            const valueResult = response.data.data;
            this.results.push(valueResult)
            let type = valueResult.cosValue.highestValue
            this.reportText.map((item,index)=>{
              if(item.type==type){
                this.typeIndex = index
              }
            })
            // 弹幕
            let num = Math.round(Math.random()),
            text = '的价值观类型居然是'+type
            if(num){
              text='居然是一个'+type+'的人'
            }
            store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    },
  }
}
</script>
<style scoped>
</style>
